import React, { useState } from 'react';
import './WhyChooseUs.css';
import { FaPhoneAlt } from 'react-icons/fa';
import feature1 from '../assets/why1.png';
import feature2 from '../assets/why2.png';
import feature3 from '../assets/why3.png';
import feature4 from '../assets/why4.png';
import feature5 from '../assets/why5.png';
import feature6 from '../assets/why6.png';
import feature7 from '../assets/why7.png';
import videoImg from '../assets/why-video.png'; // placeholder
import bannerVideo from '../assets/driveinvideobanner.mp4';
import { motion } from 'framer-motion';

const defaultFeatures = [
  { icon: feature1, text: 'Touchless Wash – No scratches, no swirl marks with our automatic car wash machine near me' },
  { icon: feature2, text: '360° Rotating Arms – Stainless steel build for reliability in a premium car spa in Bangalore' },
  { icon: feature3, text: '6–10 Minute Washes – Quick, efficient, perfect for busy lives seeking an automatic car wash machine near me' },
  { icon: feature4, text: 'Water Efficient – Uses only 90–160L per car in our premium car spa in Bangalore' },
  { icon: feature5, text: 'Low Chemical Use – High efficiency with minimal waste, ideal for professional car detailing services' },
  { icon: feature6, text: 'Smart Diagnostics – Digital sensors and remote troubleshooting for advanced automatic car wash machine near me' },
  { icon: feature7, text: 'Eco-Conscious – Optionally integrated with water recycling in a premium car spa in Bangalore' },
];

const WhyChooseUs = ({ features = defaultFeatures, image = videoImg }) => {
  const [showVideo, setShowVideo] = useState(false);

  const handleOpenVideo = () => setShowVideo(true);
  const handleCloseVideo = (e) => {
    // Only close if clicking the overlay, not the video itself
    if (e.target.classList.contains('whychoose-modal-overlay')) {
      setShowVideo(false);
    }
  };

  return (
    <section className="whychoose-section">
      <div className="whychoose-topbar container">
        <div className="whychoose-title">Why Choose <br />Us</div>
        <div className="whychoose-help">
          <span className="whychoose-help-icon"><FaPhoneAlt /></span>
          <div className="whychoose-help-text">
            <div className="whychoose-help-label">Get Professional Help</div>
            <div className="whychoose-help-phone">+91-8951509309</div>
          </div>
        </div>
      </div>
      <div className="whychoose-main ">
        <div className="whychoose-features">
          <div className="whychoose-features-col ">
            {features.slice(0, 4).map((f, i) => (
              <div className="whychoose-feature" key={i}>
                <motion.img
                  src={f.icon}
                  alt="feature"
                  className="whychoose-feature-icon"
                  animate={{ scale: [1, 1.18, 1] }}
                  transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut', delay: i * 0.18 }}
                />
                <span className="whychoose-feature-text">{f.text}</span>
              </div>
            ))}
          </div>
          <div className="whychoose-features-col">
            {features.slice(4).map((f, i) => (
              <div className="whychoose-feature" key={i+4}>
                <motion.img
                  src={f.icon}
                  alt="feature"
                  className="whychoose-feature-icon"
                  animate={{ scale: [1, 1.18, 1] }}
                  transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut', delay: (i+4) * 0.18 }}
                />
                <span className="whychoose-feature-text">{f.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="whychoose-media">
          <div className="whychoose-media-img-wrap">
            <img
              src={image}
              alt="Car Wash Bay"
              className="whychoose-media-img"
            />
            <button className="whychoose-play-btn" onClick={handleOpenVideo}>
              <span className="whychoose-play-icon">▶</span>
            </button>
          </div>
        </div>
      </div>
      {showVideo && (
        <div
          className="whychoose-modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0,0,0,0.7)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={handleCloseVideo}
        >
          <div
            style={{
              position: 'relative',
              background: '#000',
              borderRadius: 8,
              maxWidth: '90vw',
              maxHeight: '80vh',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
              overflow: 'hidden',
            }}
          >
            <button
              onClick={() => setShowVideo(false)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                zIndex: 2,
                background: 'rgba(0,0,0,0.5)',
                color: '#fff',
                border: 'none',
                borderRadius: '50%',
                width: 32,
                height: 32,
                fontSize: 20,
                cursor: 'pointer',
              }}
              aria-label="Close video"
            >✕</button>
            <video
              src={bannerVideo}
              controls
              autoPlay
              style={{
                width: '80vw',
                maxWidth: 600,
                height: '45vw',
                maxHeight: 340,
                background: '#000',
                display: 'block',
              }}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default WhyChooseUs; 